import Box from '../Box'
import styles from './SalesCard.module.scss'

const CardRow = ({ title, value, unassignedText = 'Unassigned', optional }) => {
  const textColorClass = value
    ? styles.value
    : optional
    ? styles.value
    : styles.unassigned

  return (
    <div className={styles.row}>
      <p className={styles.title}>{title}</p>
      <p className={textColorClass}>{value || unassignedText}</p>
    </div>
  )
}

const SalesCard = ({ customerSuccessManager, salesPerson, referrer }) => {
  return (
    <Box>
      <CardRow title="CSM" value={customerSuccessManager} />
      <CardRow title="Sales agent" value={salesPerson} />
      <CardRow title="Referrer" value={referrer} unassignedText="None" optional={true} />
    </Box>
  )
}

export default SalesCard
